import React from 'react';
import { MapPin, Clock, Store, Package, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';

export const MerchantCard = ({ merchant }) => {
    const navigate = useNavigate();

    const handleViewProducts = () => {
        navigate(`/merchant/${merchant.alias}`);
    };

    return (
        <div
            className="bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden group"
            data-testid={`merchant-card-${merchant.alias}`}
        >
            {/* Banner Image */}
            <div className="relative h-32 bg-gradient-to-br from-[#0052CC] to-[#0066FF] overflow-hidden">
                {merchant.store_avatar ? (
                    <img
                        src={merchant.store_avatar}
                        alt={merchant.store_name}
                        className="w-full h-full object-cover"
                    />
                ) : (
                    <div className="w-full h-full flex items-center justify-center">
                        <Store className="w-16 h-16 text-white/30" />
                    </div>
                )}

                {/* Status Badge */}
                <div className="absolute top-3 right-3">
                    <span
                        className={`
              px-2.5 py-1 rounded-full text-xs font-semibold flex items-center gap-1 backdrop-blur-sm
              ${merchant.is_open === 'open'
                                ? 'bg-green-500/90 text-white'
                                : 'bg-red-500/90 text-white'
                            }
            `}
                        data-testid="merchant-status"
                    >
                        <Clock className="w-3 h-3" />
                        {merchant.is_open === 'open' ? 'Buka' : 'Tutup'}
                    </span>
                </div>
            </div>

            {/* Merchant Info */}
            <div className="p-4">
                <h3
                    className="font-heading font-bold text-base text-gray-900 mb-1 truncate"
                    data-testid="merchant-name"
                >
                    {merchant.store_name}
                </h3>

                <p className="text-xs text-gray-500 line-clamp-2 mb-3 min-h-[32px]">
                    {merchant.address}
                </p>

                {/* Meta Information */}
                <div className="space-y-1.5 mb-4">
                    <div className="flex items-center gap-1.5 text-xs text-gray-600">
                        <MapPin className="w-3.5 h-3.5 text-[#0052CC] flex-shrink-0" />
                        <span className="font-medium">{merchant.distance}</span>
                    </div>

                    <div className="flex items-center gap-1.5 text-xs text-gray-600">
                        <Package className="w-3.5 h-3.5 text-[#0052CC] flex-shrink-0" />
                        <span><strong>{merchant.total_product}</strong> Produk</span>
                    </div>
                </div>

                {/* View Products Button */}
                <Button
                    onClick={handleViewProducts}
                    className="w-full bg-[#0052CC] hover:bg-[#0043A8] text-white rounded-lg py-2 text-sm font-semibold group-hover:shadow-sm transition-all"
                    data-testid="view-products-btn"
                >
                    Lihat Produk
                    <ChevronRight className="w-4 h-4 ml-1 group-hover:translate-x-0.5 transition-transform" />
                </Button>
            </div>
        </div>
    );
};

export default MerchantCard;
